/* eslint-disable react/jsx-key */
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useState, useCallback, useEffect, useContext } from 'react'
import moment from 'moment';
import { useLocation, useSearchParams } from 'react-router-dom';
import Filters from '../Offers/Filters';
import BulkOfferListing from './bulkOfferListing'
import SubscribedOfferListing from './subscribedOfferListing'
import { Calendar } from 'react-calendar';
import { distributorService } from '../../service/distributor.service';
import OfferSkeletonCard from '../Offers/OfferSkeletonCard';
import HeaderContext from '../../Components/Context/HeaderContext';

const BulkOffer = () => {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    const [bulkOfferList, setbulkOfferList] = useState([])
    const [loading, setLoading] = useState(true);
    const [totalPage, setTotalPage] = useState('');
    const [emptyData, setEmptyData] = useState(false);
    const [alldata, setalldata] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [searchValue, setsearchValue] = useState('');
    const [filterValue, setfilterValue] = useState('');
    const [sort,setsort]=useState(false);
    const [yeskey, setyesKey] = useState(false);
    const [responsivePopup, setresponsivePopup] = useState(false)
    const [dateToggle, setdateToggle] = useState({
        start_date:false,
        end_date:false
    })
    const [dateselected, setdateselected] = useState({
        start_date: '',
        end_date: '',
    });
    const [filters, setfilters] = useState({
        offer_type:[],
        start_date:'',
        end_date:'',
    })

    const sortValues=[
        {
            id:3,
            name:'Expiry Date: Closest first',
            label:'Expiry Date: Closest first',
            value:'end_date+asc',
            subValue:'offer_expiry_date+asc'
        },
        {
            id:4,
            name:'Expiry Date: Closest last',
            label:'Expiry Date: Closest last',
            value:'end_date+desc',
            subValue:'offer_expiry_date+desc'
        },
    ]

    const [searchParams, setSearchParams] = useSearchParams();
    let current_tab = 'bulk_offer'
    let curretSort = 'start_date+desc'
    if(searchParams.get('bulk')){
        current_tab = 'bulk_offer'
        curretSort =  'start_date+desc'
    }
    if(searchParams.get('subscribed')){
        current_tab = 'subscribed_offer'
        curretSort =  'created_at+desc'
    }
    const [tab, setTab] = useState(current_tab)
    const [sortType, setsortType] = useState(curretSort);

    const handleDate=(key,value)=>{
        setfilters((prevState)=>({
            ...prevState,
            [key]:value
        }))
    }

    const generateUrl = (val) => {
        let final = ``;
        if(filters.offer_type.length > 0 &&filters.offer_type.length ===1){
            final = `&offer_type=${filters.offer_type[0]}`
        }
        if(dateselected.start_date !=='' &&dateselected.end_date!==''){
            if(moment(dateselected.end_date).diff(moment(dateselected.start_date))>=0){
                final+=`&expiry_range=${moment(dateselected.start_date).format('YYYY-MM-DD')},${moment(dateselected.end_date).format('YYYY-MM-DD')}`
            }else{
                SetErrorMessage('End Date should be greater than or equal to start date');
                return
            }
        }else{
            if(dateselected.start_date !=='' &&dateselected.end_date===''){
                handleErrorMessge();
                return
            }
            if(dateselected.start_date ==='' &&dateselected.end_date!==''){
                handleErrorMessge();
                return
            }    
        }
        setCurrentPage(1)
        setfilterValue(final)
        return final;
    };

    const handleDateToggle = (key)=>{
        setdateToggle((prevState)=>({
            ...prevState,
            [key]:!dateToggle[key]
        })) 
    }

    const [sortSelected,setsortSelected]=useState({
        id:3,
        name:'Expiry Date: Closest first',
        label:'Expiry Date: Closest first',
        value:'end_date+asc'     
    })

    const [subscription, setSubscription] = useState([])
    const [filterQuery, setFilterQuery] = useState({page:1,limit:10,sort:"created_at asc"})
    

    const handleFetchBulkOfferList = useCallback(((sort) => {
        setLoading(true)
        distributorService.BulkOfferList(currentPage, sort !== undefined?sort :sortType, searchValue, filterValue).then((response) => {
            if (response.error === false && response.data.success_status === true) {
                if (response.data.data.Items.length === 0) {
                    setLoading(false);
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                    setLoading(false);
                }
                setbulkOfferList(response.data.data.Items);
                setalldata(response);
                setCurrentPage(response.data.data.current_page);
                setTotalPage(response.data.data.number_of_pages);
                setLoading(false);
            } else {
                SetErrorMessage(response.message.message)
                setcolorValue('red')
                setLoading(false)
                setfilterValue('')
                setTimeout(() => {
                    SetErrorMessage('')
                    setcolorValue('')                  
                }, 1000);
            }
        });
    }), [currentPage, searchValue, sortType, filterValue]);

    const handleFetch = useCallback(
        async(sort) => {
            setLoading(true)
            const subscription = await distributorService.SubscriptionList(currentPage, sort !== undefined?sort :sortType, searchValue, filterValue);
            if(!subscription.error && subscription.data.data.success_status){
                if (subscription.data.data.Items.length === 0) {
                    setEmptyData(true);
                } else {
                    setEmptyData(false);
                }
                setSubscription(subscription.data.data.Items)
                setCurrentPage(subscription.data.data.current_page);
                setTotalPage(subscription.data.data.number_of_pages);
                setalldata(subscription);   
                setLoading(false);                 
            }
        },
        [currentPage, searchValue, sortType, filterValue],
    )

    const handleClear=()=>{
        setdateselected({
            start_date: '',
            end_date: '',
        })
        setfilterValue('')    
        if (tab === 'bulk_offer') {
            handleFetchBulkOfferList();
        } else {
            handleFetch();
        }  
    }   
    const handlePageClick = async (data) => {
        setLoading(false);
        const page = data.selected + 1;
        setCurrentPage(page);
    };

    useEffect(() => {
        if (tab === 'bulk_offer') {
            handleFetchBulkOfferList();
        } else {
            handleFetch();
        }
    }, [tab, searchValue, currentPage, filterValue]);

    return (
        <div className="flex">
            <Filters 
                setfilters={setfilters}
                Filters={filters}
                generateUrl={generateUrl}
                handleClear={handleClear}
                loading={loading}
                dateToggle={dateToggle}
                setdateToggle={setdateToggle}
                handleDateToggle={handleDateToggle}
                handleDate={handleDate}
                responsivePopup={responsivePopup}
                setresponsivePopup={setresponsivePopup}
                yeskey={yeskey}
                dateselected={dateselected}
                setdateselected={setdateselected}
                tab={tab}
                filterValue={filterValue}
            />

            <div className="xl:ml-[22%] xl:w-[78%] w-full lg:px-[18px] md:px-[46px] px-4 pt-[21px] pb-10">
                <div className="w-full">
                    <div className="flex justify-between itrems-center flex-wrap -mx-2">
                        <div className="px-2 mb-4">
                            <ul className="nav nav-pills flex items-start list-none pl-0 w-fit" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow text-start w-fit" role="presentation" onClick={() => { setsortType('start_date+desc'); setTab('bulk_offer'); setSearchParams({'bulk':true})}}>
                                    <a href="javascript:void(0)" className={`nav-link block sm:text-f7 text-f8 font-semibold text-[#555259] bulk-offer ${tab === 'bulk_offer' ? 'active' : ''} relative w-full`} id="pills-priceranje" data-bs-toggle="pill" data-bs-target="#pills-pricetab" role="tab"
                                        aria-controls="pills-price" aria-selected="true">
                                        Bulk Offers
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-fit ml-5" role="presentation" onClick={() => { setsortType('created_at+desc'); setTab('subscribed_offer'); setSearchParams({'subscribed':true})}}>
                                    <a href="javascript:void(0)" className={`nav-link block sm:text-f7 text-f8 font-semibold text-[#555259] ${tab === 'subscribed_offer' ? 'active' : ''} bulk-offer relative w-full`} id="pills-categories" data-bs-toggle="pill" data-bs-target="#pillcategorie" role="tab"
                                        aria-controls="pillcategorie" aria-selected="false">
                                        My Subscribed Offers
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="px-2">
                            <div className="flex items-center flex-wrap -mx-[5px]">
                                <div className="xl:hidden block mb-4 px-[5px]">
                                    <div className="flex items-center pr-5">
                                        <button id ="filtermodalbutton" type="button" data-bs-toggle="modal" data-bs-target="#filtermodal" className="flex items-center">
                                            <img src="/images/filter.svg" alt="icon" className="cursor-pointer w-3.5 h-3.5"/>
                                            <p className="sm:text-base text-xs6 font-semibold text-[#808285] cursor-pointer pl-1">Filter</p>
                                        </button>
                                    </div>
                                </div>
                                <div className="dropdown relative mb-4 px-[5px]">
                                    <button type="button" id="reportDropdown" data-bs-toggle="dropdown" aria-expanded="false" className="flex items-center bg-[#F5F5FA] rounded-md px-3 py-1.5" onClick={()=>setsort(!sort)}>
                                        <span className="text-xs font-bold text-[#090406] dropdown-sort">Sort by</span>
                                        <img src="/images/Down-dark.svg" alt="icon" className="pl-1"/>
                                    </button>
                                    <ul className={`dropdown-menu w-max absolute ${sort?'show':'hidden'} top-[35px] left-0  bg-[#FFFFFF] rounded-lg shadow-s11 z-[999] pl-4 pr-3.5 py-3.5`} aria-labelledby="reportDropdown">
                                        {sortValues.map((item) => (
                                            <li className="w-full bg-[#ffffff]" key={item.id} onClick={()=>{
                                                setsortSelected(item);
                                                tab === 'bulk_offer'? handleFetchBulkOfferList(item.value): handleFetch(item.subValue)
                                                setTimeout(() => {
                                                    setsort(false);
                                                }, 1000);
                                            }}>
                                                <a href="#" className="dropdown-item">
                                                    <div className="w-full flex items-center">
                                                        <div className="relative checkbox custom-checkbox custom-radio1 flex items-center">
                                                            <input type="radio" id={`checkbox-${item.id}`} name="radiodate" className="cursor-pointer"/>
                                                            <label htmlFor={`checkbox-${item.id}`} className={`sm:text-base text-sm font-noraml text-[#555259] pl-6 high cursor-pointer ${sortSelected.value!==item.value?'font-semibold':'hidden font-normal'}}`}>{item.label}</label>
                                                            <label htmlFor={`checkbox-${item.id}`} className={`sm:text-base text-sm font-semibold text-[#555259] pl-6 low cursor-pointer ${sort && sortSelected.value===item.value?'font-semibold':'hidden font-normal'}`}>{item.label}</label>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>

                                        ))}
                                    </ul>
                                </div>
                                <div className="relative mb-4 px-[5px]">
                                    <label htmlFor="search"></label>
                                    <input  value={searchValue}
                                        onChange={(e) => {
                                            setsearchValue(e.target.value);
                                            setCurrentPage(1);
                                        }}
                                        autoComplete="off"
                                        type="text" 
                                        name="search"
                                        id="search"
                                        className="sm:w-[235px] w-full h-9 bg-[#FFFFFF] rounded-lg outline-0 shadow-s3 text-xs2 font-semibold text-[#808285] placeholder:font-semibold placeholder:text-xs2 placeholder:text-[#808285] pl-[35px]" placeholder="Search"/>
                                    <img src="/images/Group-279.svg" alt="icon" className="absolute top-3 left-[15px] cursor-pointer"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading && <OfferSkeletonCard />}
                    {!loading &&
                    <div className="sm:pt-[25px] ">
                        <div className="tab-content" id="pills-tabContentVertical">
                            {tab === 'bulk_offer' ? 
                                <BulkOfferListing 
                                    tab={tab}
                                    setTab={setTab}
                                    bulkOfferList={bulkOfferList}
                                    totalPage={totalPage}
                                    currentPage={currentPage}
                                    alldata={alldata}
                                    loading={loading}
                                    emptyData={emptyData}
                                    setCurrentPage={setCurrentPage}
                                    setLoading={setLoading}
                                    setbulkOfferList={setbulkOfferList}
                                    searchValue={searchValue} /> : 
                                <SubscribedOfferListing 
                                    tab={tab}
                                    setTab={setTab}
                                    subscription={subscription}
                                    setSubscription={setSubscription}
                                    filterQuery={filterQuery}
                                    setFilterQuery={setFilterQuery}
                                    totalPage={totalPage}
                                    currentPage={currentPage}
                                    loading={loading}
                                    setLoading={setLoading}
                                    handlePageClick={handlePageClick}
                                    alldata={alldata}
                                    emptyData={emptyData}
                                    searchValue={searchValue}
                                />}
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    )
}

export default BulkOffer